import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useState,} from 'react'
import {useLocation} from 'react-router-dom'
import {nest} from 'recompose'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import Courses from "./Courses";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import CourseDetail from "./CourseDetail";
import WorkspaceContext from "../../WorkspaceContext";
import _ from "lodash"
import CourseClassDetail from "./CourseClassDetail";

export const CourseContainerContext = React.createContext(
    {}
)

const CourseContainerProvider = ({children}) => {
    const currentCourseId = useRouteSearchParam("current_course_id")
    const currentCourseClassId = useRouteSearchParam("current_course_class_id")
    const [current_course_id, setCurrentCourseId] = useState(currentCourseId)
    const [current_course_class_id, setCurrentCourseClassId] = useState(currentCourseClassId);

    const {onChangeSearchParams} = useRouterSearchParam({})

    const onSelectCourseContainerRoute = (values) => {
        if (_.has(values, 'current_course_id')) setCurrentCourseId(values?.current_course_id)
        if (_.has(values, 'current_course_class_id')) setCurrentCourseClassId(values?.current_course_class_id)

        onChangeSearchParams(values, 'replace')
    }

    return (
        <CourseContainerContext.Provider
            value={{
                current_course_id, setCurrentCourseId,
                current_course_class_id, setCurrentCourseClassId,
                ...{onSelectCourseContainerRoute}
            }}>
            {children}
        </CourseContainerContext.Provider>
    )
}


const CourseContainer = () => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const {isSm} = useContext(LayoutContext)
    const {organization} = useContext(WorkspaceContext);
    const currentCourseId = useRouteSearchParam("current_course_id")
    const currentCourseClassId = useRouteSearchParam("current_course_class_id")
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
    } = useContext(CourseContainerContext)


    useEffect(() => {
        setCurrentCourseId(currentCourseId)
    }, [currentCourseId])
    useEffect(() => {
        setCurrentCourseClassId(currentCourseClassId)
    }, [currentCourseClassId])


    if (!!current_course_id && !!current_course_class_id) {
        return (
            <CourseClassDetail/>
        )
    } else if (!!current_course_id && !!!current_course_class_id) {
        return (
            <CourseDetail/>
        )
    }

    return (
        <Courses owner_id={organization?.id} owner_type={organization?._type}/>
    )
}


export default nest(CourseContainerProvider, CourseContainer)
